var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffenceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "offence-icon",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon",
    width: 56,
    height: 56,
    rx: 7,
    transform: "translate(12 12)",
    fill: "#f0f1fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_switch_on_2",
    d: "M3.091,0A3.079,3.079,0,0,0,0,3.02V15.1a3.079,3.079,0,0,0,3.091,3.02H30.909A3.079,3.079,0,0,0,34,15.1V3.02A3.079,3.079,0,0,0,30.909,0Zm0,3.02H30.909V15.1H3.091Zm17,1.51v9.06h9.273V4.53Z",
    transform: "translate(48.143 23) rotate(90)",
    fill: "#1b1d29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffenceIcon);
export default __webpack_public_path__ + "static/media/offence-icon.4b544a514bf2f43ff896cb0db00e2249.svg";
export { ForwardRef as ReactComponent };